"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NHSCLRN_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var NHSCLRN_Factory = /** @class */ (function () {
    function NHSCLRN_Factory() {
    }
    NHSCLRN_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            ContractNumber: model.ContractNumber,
            LastClaimNo: model.LastClaimNo,
            PerformerNumber: model.PerformerNumber,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
        };
        return result;
    };
    NHSCLRN_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            ContractNumber: model.ContractNumber,
            LastClaimNo: model.LastClaimNo,
            PerformerNumber: model.PerformerNumber,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
        };
        return result;
    };
    return NHSCLRN_Factory;
}());
exports.NHSCLRN_Factory = NHSCLRN_Factory;
